export const blockIconsSocialEmojiPeopleNew = (
	<span className='material-symbols-outlined'>emoji_people</span>
);
